import { LogLevel } from '@azure/msal-browser';

const authorityUrl = process.env.REACT_APP_AUTH_AUTHORITY || '';
const knownAuthorityHost = (() => {
    try {
        return authorityUrl ? new URL(authorityUrl).hostname : '';
    } catch {
        return '';
    }
})();

/**
 * MSAL redirect URI. CRA bakes REACT_APP_AUTH_REDIRECT_URI at build time; for any
 * non-local host (custom domain or *.azurewebsites.net) we use the current page
 * origin so login returns to the same host the user opened (avoids a stale
 * build-time value pointing at the default App Service URL).
 */
const getBrowserRedirectUri = () => {
    if (typeof window === 'undefined') {
        return process.env.REACT_APP_AUTH_REDIRECT_URI || '';
    }
    const host = window.location.hostname;
    const isLocal = host === 'localhost' || host === '127.0.0.1' || host === '[::1]';
    if (isLocal) {
        return process.env.REACT_APP_AUTH_REDIRECT_URI || window.location.origin;
    }
    return window.location.origin;
};

export const getMsalConfig = () => {
    const redirectUri = getBrowserRedirectUri();
    return {
    auth: {
        clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
        authority: authorityUrl,
        knownAuthorities: knownAuthorityHost ? [knownAuthorityHost] : [],
        redirectUri,
        postLogoutRedirectUri: redirectUri,
        navigateToLoginRequestUrl: true,
        validateAuthority: true
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false
    },
    system: {
        allowNativeBroker: false,
        loggerOptions: {
            logLevel: LogLevel.Error,
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                if (level === 0) {
                    console.error(message);
                }
            }
        }
    }
    };
};

export const loginRequest = {
    scopes: [
        "openid",
        "profile",
        "offline_access",
        process.env.REACT_APP_AUTH_API_SCOPE
    ]
};

// Returns the canonical email we use to key the user in Cosmos DB.
// For accounts that signed in with an external IdP (e.g. Google federated
// through Entra External ID), MSAL sets `account.username` to the internal
// CIAM UPN (`{objectId}@{tenant}.onmicrosoft.com`) rather than the real
// email. The backend derives the user from the `email` ID-token claim, so
// always prefer that claim here to keep the two sides in sync.
export const getUserEmail = (account) => {
    if (!account) return null;
    const claims = account.idTokenClaims || {};
    return (
        claims.email ||
        (Array.isArray(claims.emails) ? claims.emails[0] : null) ||
        account.username ||
        null
    );
};
